module.exports = {"schedule":{"title":"日程","now_playing":"当前进行中","empty":{"title":"未找到内容","detail":"当前没有即将开始的项目"}}}